import { OperationVariables, ApolloQueryResult } from '@apollo/client'
import { Modal, Paper, Slide } from '@material-ui/core'

import { getDirection } from '../../../localization'
import { ReservedField } from '../../../types/inventory'
import { ModalTable } from './modalTable'
import useStyles from './styles/index'

interface ReserveModalProps {
  isOpen: boolean
  onClose: () => void
  data: ReservedField[]
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      reservedFields: ReservedField[]
    }>
  >
  loading: boolean
}

const ReserveModal: React.FC<ReserveModalProps> = ({
  isOpen,
  onClose,
  data,
  refetch,
  loading
}) => {
  const classes = useStyles()

  return (
    <Modal
      dir={getDirection()}
      open={isOpen}
      onClose={onClose}
      className={classes.modal}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.deletePaper}>
          <ModalTable data={data} refetch={refetch} loading={loading} />
        </Paper>
      </Slide>
    </Modal>
  )
}

export default ReserveModal
